export function tranlatesFilter($rootScope) {
    "ngInject"

    return (value, lang) => {
        if (value) {
            value = value.toString().replace(/(\r\n|\n|\r)/gm, "");
            value = value.split(' ')
            value = value.join('_')
        }
        if (!$rootScope.translate) {
            console.warn('$rootScope.translate not find');
            return value;
        }
        else {
            if (!$rootScope.translate[lang]) {
                console.warn(`can't find translate ${lang} in $rootScope.translate`);
                return value;
            }
            else {
                if (!$rootScope.translate[lang][value]) {
                    console.warn(`can't find value ${value} in translate ${lang} in $rootScope.translate`);
                    return value;
                }
                else {
                    return $rootScope.translate[lang][value];
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/filters/translates/translates.filter.ts